import { templateSettingsSchema, TrackingType } from "@patient-watch/types";
import { z } from "zod";

/** Search params carried through manual update + template-driven flows so review → existing-trackers → intervention keeps template data. */
export const updateDiaryFlowSearchSchema = templateSettingsSchema.partial().extend({
    type: z.enum(["intervention", "questionnaire", "both"]).default("both"),
    reference_date: z.string().optional(),
    shared_attribute_id: z.string().uuid().optional(),
    event_type: TrackingType.optional(),
    /** When set, intervention-details forms return here instead of continuing the add-event wizard. */
    from: z.enum(["worklist"]).optional(),
    /** Legacy single-tracker (some deep links). */
    form_id: z.string().uuid().optional(),
    schedule_id: z.string().uuid().optional(),
    /** Patients table state to restore after the update flow completes. */
    columns: z.string().optional(),
    style: z.enum(["table", "stack"]).optional(),
    tab: z.enum(["active", "pending", "inactive"]).optional(),
    diaries: z.enum(["direct", "all", "mine"]).optional(),
    organisations: z.array(z.string()).optional(),
    diary_access: z.array(z.string().uuid()).optional(),
    diary_types: z.array(z.string()).optional(),
    labels: z.array(z.string()).optional(),
    pagination: z
        .object({
            pageSize: z.number(),
            pageIndex: z.number(),
        })
        .optional(),
    sorting: z
        .array(
            z.object({
                desc: z.boolean(),
                id: z.string(),
            })
        )
        .optional(),
    refetcher: z.number().optional(),
});

export type UpdateDiaryFlowSearch = z.infer<typeof updateDiaryFlowSearchSchema>;

export const updateDiaryMessageSearchSchema = updateDiaryFlowSearchSchema.extend({
    contact_id: z.string().uuid(),
});
